"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMarketTrendGradient = exports.getHouseTrendGradient = exports.getGradientOfferPrice = exports.getGradientEstimatedPrice = exports.getCanvasGradient = void 0;
var _constants = require("./constants");
const getCanvasGradient = (ctx, stopColors) => {
  const gradient = ctx.createLinearGradient(0, 0, 0, _constants.CHART_HEIGHT);
  stopColors.forEach(_ref => {
    let {
      offset,
      color
    } = _ref;
    return gradient.addColorStop(offset, color);
  });
  return gradient;
};
exports.getCanvasGradient = getCanvasGradient;
const getGradientEstimatedPrice = ctx => getCanvasGradient(ctx, [{
  offset: 0.1,
  color: 'rgba(4, 104, 255, 0.24)'
}, {
  offset: 1,
  color: 'rgba(4, 104, 255, 0)'
}]);
exports.getGradientEstimatedPrice = getGradientEstimatedPrice;
const getGradientOfferPrice = ctx => getCanvasGradient(ctx, [{
  offset: 0.2,
  color: 'rgba(255, 126, 0, 0.06)'
}, {
  offset: 1,
  color: 'rgba(255, 126, 0, 0)'
}]);
exports.getGradientOfferPrice = getGradientOfferPrice;
const getHouseTrendGradient = ctx => getCanvasGradient(ctx, [{
  offset: 0.2,
  color: 'rgba(139, 0, 139, 0.06)'
}, {
  offset: 1,
  color: 'rgba(139, 0, 139, 0)'
}]);
exports.getHouseTrendGradient = getHouseTrendGradient;
const getMarketTrendGradient = ctx => getCanvasGradient(ctx, [{
  offset: 0.1,
  color: 'rgba(4, 104, 255, 0.24)'
}, {
  offset: 1,
  color: 'rgba(4, 104, 255, 0)'
}]);
exports.getMarketTrendGradient = getMarketTrendGradient;